import React, { useState } from 'react';
import styles from './style.scss';
import RatingPlaceHolder from '../../dc/ratingPlaceholder';

const RatingScale = props => {
    const [selected, updateSelection] = useState(0);
    let limit = 10;

    const getScaleBox = () => {
        let arr = [];
        for (var i = 1; i <= limit; i++) {
            arr.push(
                <RatingPlaceHolder
                    index={i}
                    onChange={props.onChange}
                    selected={selected}
                    updateSelection={updateSelection}
                />
            )
        }
        return arr;
    }
    return (
        <>
            <div className={styles['scale-txt']}>{props.subTitle}</div>
            <div className={styles['scale-holder']}>
                {getScaleBox()}
            </div>
            <div className={styles['grade-txt']}>
                <span>Very Bad</span>
                <span>Amazing</span>
            </div>
        </>
    )
};

export default RatingScale;